<!--
 * @Author: natsu
 * @Date: 2020-12-23 09:51:50
 * @LastEditors: natsu
 * @LastEditTime: 2021-03-30 08:34:53
 * @Description: file content
-->
<template>
  <div class="wrapper">
    <header class="bg">
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/vant.png" /></div>
      <p>Vant</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/vant/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "3.0.10",
          linkList: [ur + "3.0.10/vant.min.js", ur + "3.0.10/index.css"]
        },
        {
          label: "3.0.0",
          linkList: [ur + "3.0.0/vant.min.js", ur + "3.0.0/index.css"]
        },
        {
          label: "2.12.54",
          linkList: [ur + "2.12.54/vant.min.js", ur + "2.12.54/index.css"]
        },
        {
          label: "2.12.10",
          linkList: [ur + "2.12.10/vant.min.js", ur + "2.12.10/index.css"]
        },
        {
          label: "2.12.0",
          linkList: [ur + "2.12.0/vant.min.js", ur + "2.12.0/index.css"]
        },
        {
          label: "2.11.0",
          linkList: [ur + "2.11.0/vant.min.js", ur + "2.11.0/index.css"]
        },
        {
          label: "2.6.3",
          linkList: [ur + "2.6.3/vant.min.js", ur + "2.6.3/index.css"]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListVant.vue